import { ProfileV2ActionTypes } from './profileV2.actionTypes';

export const profileV2Reset = () => ({
  type: ProfileV2ActionTypes.PROFILE_V2_RESET,
});
